/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@chakra-ui/button";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { useDisclosure } from "@chakra-ui/hooks";
import { AddIcon } from "@chakra-ui/icons";
import { Input } from "@chakra-ui/input";
import { Box, Heading } from "@chakra-ui/layout";
import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/modal";
import { Skeleton } from "@chakra-ui/skeleton";
import { useToast } from "@chakra-ui/toast";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { v4 } from "uuid";
import { useAuth } from "../../contexts/authContext";
import firebase from "../../firebase";
import {
	clubObjectConstructor,
	userObjectConstructor,
} from "../../helpers/objects";
import theme from "../../helpers/theme";
import { ClubCard } from "./ClubCard";

const unsupportedApology =
	"We're sorry, but your school isn't currently supported. go to our main page and press the apply button to get your school started!.";

const noClubsApology =
	"We're sorry, but your school doesn't have any clubs. Ask someone to create one!";

const noGlobalsApology = "Sorry, there are currently no global clubs";
const noJoinedApology = "Please join a club first, it will then appear here.";

export const ClubList = ({ clubs: clubTypes }) => {
	// const [isLoading, setIsLoading] = useState(false);
	const [schoolApology, setSchoolApology] = useState(false);

	const [clubs, setClubs] = useState([]);
	const [user, setUser] = useState();
	const { isOpen, onOpen, onClose } = useDisclosure();

	const toast = useToast();
	const { currentUser } = useAuth();

	// references

	const titleRef = useRef();
	const imageRef = useRef();
	const badge1Ref = useRef();
	const badge2Ref = useRef();

	// fetch the school clubs

	useEffect(() => {
		const userRef = firebase
			.firestore()
			.collection("users")
			.doc(currentUser.uid);
		const unsubscribe = userRef.onSnapshot(dbuser => {
			if (!dbuser.data() || !dbuser.data().id) {
				userRef.set(
					userObjectConstructor({
						id: currentUser.uid,
						role: "student",
						settings: { notifs: "all" },
					})
				);
			} else setUser(dbuser.data());
		});
		return unsubscribe;
	}, []);

	const fetchSchool = async id => {
		const email = currentUser.email;

		if (email.search(".edu") === -1 && email.search("qoobes") === -1)
			return false;

		const extension = email.split("@")[1].split(".")[0];

		const school = await firebase
			.firestore()
			.collection("schools")
			.doc(extension)
			.get();

		return school.exists;
	};
	const fetchGlobalClubs = () => {
		const unsubscribe = firebase
			.firestore()
			.collection("schools")
			.doc("global")
			.collection("clubs")
			.onSnapshot(raw => {
				if (raw.docs.length <= 0) {
					setSchoolApology(noGlobalsApology);
					return;
				}
				setSchoolApology(false);

				const data = raw.docs.map(doc => ({
					data: doc.data(),
					id: doc.id,
				}));
				setClubs(data);
			});
		return unsubscribe;
	};

	const fetchMyClubs = () => {
		const unsubscribe = firebase
			.firestore()
			.collectionGroup("clubs")
			.where("members", "array-contains", currentUser.uid)
			.onSnapshot(raw => {
				if (raw.docs.length <= 0) {
					setSchoolApology(noJoinedApology);
					return;
				}
				setSchoolApology(false);

				const data = raw.docs.map(doc => ({
					data: doc.data(),
					id: doc.id,
				}));
				setClubs(data);
			});

		return unsubscribe;
	};

	useEffect(() => {
		if (clubTypes === "school") {
			fetchSchool(currentUser.uid).then(exists => {
				if (!exists) {
					setSchoolApology(unsupportedApology);
					return;
				}
				setSchoolApology(false);

				const schoolName = currentUser.email
					.split("@")[1]
					.split(".")[0];

				const unsubscribe = firebase
					.firestore()
					.collection("schools")
					.doc(schoolName)
					.collection("clubs")
					.onSnapshot(raw => {
						if (raw.docs.length <= 0) {
							setSchoolApology(noClubsApology);
							return;
						}
						setSchoolApology(false);

						const data = raw.docs.map(doc => ({
							data: doc.data(),
							id: doc.id,
						}));
						setClubs(data);
					});

				return unsubscribe;
			});
		} else if (clubTypes === "global") {
			const unsubscribe = fetchGlobalClubs();
			return unsubscribe;
		} else if (clubTypes === "mine") {
			const unsubscribe = fetchMyClubs();
			return unsubscribe;
		} else
			toast({
				title: "Something went wrong",
				description: "Please report this to us",
				status: "error",
				duration: "600",
			});
	}, [clubTypes]);

	const createClub = e => {
		e.preventDefault();

		// badges, max 2
		// title
		// imageUrl
		// verified:false

		const title = titleRef.current.value;
		const image = imageRef.current.value;
		const badges = [badge1Ref.current.value, badge2Ref.current.value];

		if (title.length < 5)
			return toast({
				title: "Title too short",
				description: "Please enter a logner title",
				status: "error",
			});
		if (image.length < 5)
			return toast({
				title: "Pleas include an image",
				description: "Missing iamge",
				status: "error",
			});

		const club = clubObjectConstructor({
			title,
			imageUrl: image,
			badges: badges || [],
		});

		const school = currentUser.email.split("@")[1].split(".")[0];
		const newid = v4();

		firebase
			.firestore()
			.collection("schools")
			.doc(school)
			.collection("clubs")
			.doc(newid)
			.set({
				...club,
				id: newid,
			});

		onClose();
	};

	return (
		<Skeleton borderRadius="lg" isLoaded={true}>
			{schoolApology ? (
				<Box
					width="100%"
					display="flex"
					justifyContent="center"
					alignItems="center"
					// style={{ gap: "0.8rem" }}
				>
					<Heading size="md">{schoolApology}</Heading>
				</Box>
			) : (
				<>
					{user && user.role === "admin" && (
						<>
							<Modal isOpen={isOpen} onClose={onClose} isCentered>
								<ModalOverlay />
								<ModalContent>
									<ModalHeader>Modal Title</ModalHeader>
									<ModalCloseButton />

									<form onSubmit={createClub}>
										<ModalBody>
											<FormControl>
												<FormLabel>Title</FormLabel>
												<Input
													focusBorderColor={
														theme.colours.accent +
														".400"
													}
													_focusWithin={{
														backgroundColor:
															"white",
													}}
													ref={titleRef}
													rounded="full"
													bgColor="gray.100"
													placeHolder="The greatest club <3"
												/>
											</FormControl>
											<FormControl mt={3}>
												<FormLabel>Image Url</FormLabel>
												<Input
													focusBorderColor={
														theme.colours.accent +
														".400"
													}
													_focusWithin={{
														backgroundColor:
															"white",
													}}
													ref={imageRef}
													rounded="full"
													bgColor="gray.100"
													placeHolder="https://image.com/image"
												/>
											</FormControl>
											<FormControl mt={3}>
												<FormLabel>Badges</FormLabel>
												<Box display="flex">
													<Input
														focusBorderColor={
															theme.colours
																.accent + ".400"
														}
														_focusWithin={{
															backgroundColor:
																"white",
														}}
														ref={badge1Ref}
														rounded="full"
														bgColor="gray.100"
														placeHolder="art"
													/>
													<Input
														focusBorderColor={
															theme.colours
																.accent + ".400"
														}
														_focusWithin={{
															backgroundColor:
																"white",
														}}
														ref={badge2Ref}
														ml={2}
														rounded="full"
														bgColor="gray.100"
														placeHolder="music"
													/>
												</Box>
											</FormControl>
										</ModalBody>

										<ModalFooter>
											<Button
												colorScheme={
													theme.colours.accent
												}
												variant="ghost"
												type="submit"
												mr={3}
											>
												Add New Club
											</Button>
											<Button
												variant="ghost"
												onClick={onClose}
												type="button"
											>
												Close
											</Button>
										</ModalFooter>
									</form>
								</ModalContent>
							</Modal>

							<Box
								d="flex"
								justifyContent="center"
								alignItems="center"
							>
								<Box
									rounded="full"
									p="3"
									borderWidth="1px"
									overflow="hidden"
									userSelect="none"
									bgColor="green.200"
									m="0.6rem"
									transition="box-shadow 200ms"
									_hover={{
										cursor: "pointer",
										boxShadow: "0 2px 5px -1px gray",
									}}
									_focus={{
										cursor: "pointer",
										boxShadow: "0 2px 5px -1px gray",
									}}
									onClick={onOpen}
								>
									<AddIcon fontSize="lg" />
								</Box>
							</Box>
						</>
					)}
					<Box
						width="100%"
						display="flex"
						flexWrap="wrap"
						justifyContent="center"
						alignItems="center"
						flex="1"
						// style={{ gap: "0.8rem" }}
					>
						{clubs.map((club, key) => (
							<Link to={`/clubs/${club.id}`} key={key}>
								<ClubCard property={club.data} />
							</Link>
						))}
					</Box>
				</>
			)}
		</Skeleton>
	);
};
